import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { Groups, Group } from '../../../typings'
import { HOME_PATH } from '../constants'

interface CurrentUserGroupsPayload {
  userType: string
  startCursor?: number
  pageSize?: number
}

export const groupApi = createApi({
  keepUnusedDataFor: 0,
  reducerPath: 'groupApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${HOME_PATH}/api/groups/`,
    prepareHeaders: (headers) => {
      headers.set('X-Requested-With', 'XMLHttpRequest')

      return headers
    },
  }),
  tagTypes: ['groups', 'eligibility', 'groupDetail'],
  endpoints: (builder) => ({
    getCurrentUserGroups: builder.query<Groups, CurrentUserGroupsPayload>({
      query: ({ userType, startCursor, pageSize }) =>
        `/list/${userType}?startCursor=${startCursor}${
          pageSize ? `&pageSize=${pageSize}` : ''
        }`,
      serializeQueryArgs: ({ queryArgs }) => {
        const newQueryArgs = { ...queryArgs }
        if (newQueryArgs.startCursor) {
          delete newQueryArgs.startCursor
        }
        if (newQueryArgs.pageSize) {
          delete newQueryArgs.pageSize
        }
        return newQueryArgs
      },
      merge: (currentCache, newItems) => {
        // During pagination we just concatenate cache with new items
        if (Number(newItems.pageInfo.startCursor) > 1) {
          currentCache.edges.push(...newItems.edges)
          return currentCache
        }

        return newItems
      },
      providesTags: (_result, _err, arg) => [
        { type: 'groups', id: arg.userType },
      ],
    }),
    getGroupDetail: builder.query<Group, string>({
      query: (id) => `/${id}`,
      providesTags: (result) => {
        if (result) {
          return [
            {
              type: 'groupDetail',
              id: result.customer.moneyPools.moneyPool.id,
            },
            'groupDetail',
          ]
        }

        return ['groupDetail']
      },
    }),
  }),
})

export type RootState = ReturnType<typeof groupApi.reducer>

export const {
  useGetCurrentUserGroupsQuery,
  useLazyGetCurrentUserGroupsQuery,
  useGetGroupDetailQuery,
} = groupApi
